module.exports = __webpack_public_path__ + "static/Inter-Light-BETA-42473eefda3520b8fa266b620c1df807.woff";